import React from 'react';
import loadable from '@loadable/component';
import { OwnProps as Props } from './view';

const ListsLoadable = loadable(() =>
  import(/* webpackChunkName: "sidebar-views" */ './view')
);

const Lists = (props: Props) => <ListsLoadable {...props} />;

export default Lists;
